// Configuración del módulo de tablero de delegados.
// Todo lo que depende del proyecto/backend está aquí para facilitar la migración.
//
// Lo que cambia entre torneos (reglas de campo, carnets, conteos, campeonato)
// sale del torneo activo: tournament.lineupRules, tournament.ageBands y
// tournament.championships. Ver docs/agregar-torneo.md.

import tournament from "@tournaments";

// Rol que puede usar el tablero (1 = delegado/técnico)
export const DELEGATE_ROLES = [1];

// Rutas del módulo
export const DELEGATE_PATH = "/delegate";
export const delegateBoardPath = (gamecode) => `${DELEGATE_PATH}/${gamecode}`;

// Estados de partido que se listan al delegado
// 1 = programado, 5 = primer tiempo, 6 = entretiempo, 7 = segundo tiempo
export const LISTED_GAME_STATUS = [1, 5, 6, 7];
export const LIVE_GAME_STATUS = [5, 6, 7];
export const HALFTIME_STATUS = 6;
export const SECOND_HALF_STATUS = 7;
// 2 = terminado, 8 = cerrado: el tablero se bloquea y se borra lo guardado del partido
export const FINISHED_GAME_STATUS = [2, 8];

// Cada cuánto se consulta el partido oficial (marcador, estado y eventos)
export const LIVE_POLL_MS = 30000;

// Parámetros de consulta de partidos del equipo (mismos que usa el calendario por equipo)
export const GAMES_QUERY = {
  championshipcode: tournament.championships.actual,
  maxDate: "2024-01-20",
  orderby: "asc",
};

// Códigos de evento de la planilla
export const EVENT = {
  STARTER: 22, // titular
  LATE_IN: 25, // ingreso post inicio
  SUB_IN: 8, // entra por sustitución
  SUB_OUT: 23, // sale por sustitución
  PRESENCE: 15, // presencia (no juega)
};
export const LINEUP_EVENTS = [15, 22, 8, 25, 23];
// Eventos de la línea de tiempo del partido (mismos de la planilla):
// goles, autogoles, amarillas, rojas, fueras de lugar, córners y cambios
export const MATCH_EVENTS = [1, 2, 4, 5, 6, 7, 8];

// Máximo de jugadores en campo
export const MAX_IN_FIELD = 11;

// Mínimo en campo para iniciar el partido: desde aquí se habilitan sustituciones
export const MIN_TO_START = 7;

// Prefijo de almacenamiento local (por partido y equipo)
export const STORAGE_PREFIX = "delegateBoard";

// Link del menú lateral para el rol delegado
export const delegateLinks = [
  {
    title: "Mi tablero de partido (BETA)",
    path: DELEGATE_PATH,
    icon: "ball",
  },
];

// Pestañas del tablero (vista celular)
export const TABS = [
  { key: "field", label: "Campo" },
  { key: "roster", label: "Plantilla" },
  { key: "moves", label: "Movimientos" },
  { key: "cards", label: "Tarjetas" },
];

// Vistas de la pestaña Campo
export const FIELD_VIEWS = [
  { key: "list", label: "Lista" },
  { key: "pitch", label: "Cancha" },
];

// Formaciones de la vista Cancha: jugadores de campo por línea, de defensa a
// delantera. El arquero va aparte en un puesto fijo. Para agregar una formación
// basta con una línea más aquí (las líneas deben sumar 10).
export const FORMATIONS = [
  { key: "4-4-2", lines: [4, 4, 2] },
  { key: "4-3-3", lines: [4, 3, 3] },
  { key: "4-2-3-1", lines: [4, 2, 3, 1] },
  { key: "4-1-4-1", lines: [4, 1, 4, 1] },
  { key: "4-5-1", lines: [4, 5, 1] },
  { key: "4-3-1-2", lines: [4, 3, 1, 2] },
  { key: "3-5-2", lines: [3, 5, 2] },
  { key: "3-4-3", lines: [3, 4, 3] },
  { key: "5-3-2", lines: [5, 3, 2] },
  { key: "5-4-1", lines: [5, 4, 1] },
];
export const DEFAULT_FORMATION = "4-4-2";
